"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _translationAr = _interopRequireDefault(require("./translation-ar.json"));
var _translationBn = _interopRequireDefault(require("./translation-bn.json"));
var _translationCs = _interopRequireDefault(require("./translation-cs.json"));
var _translationDa = _interopRequireDefault(require("./translation-da.json"));
var _translationDe = _interopRequireDefault(require("./translation-de.json"));
var _translationEn = _interopRequireDefault(require("./translation-en.json"));
var _translationEs = _interopRequireDefault(require("./translation-es.json"));
var _translationFr = _interopRequireDefault(require("./translation-fr.json"));
var _translationHe = _interopRequireDefault(require("./translation-he.json"));
var _translationHi = _interopRequireDefault(require("./translation-hi.json"));
var _translationId = _interopRequireDefault(require("./translation-id.json"));
var _translationIt = _interopRequireDefault(require("./translation-it.json"));
var _translationJa = _interopRequireDefault(require("./translation-ja.json"));
var _translationKn = _interopRequireDefault(require("./translation-kn.json"));
var _translationKo = _interopRequireDefault(require("./translation-ko.json"));
var _translationMl = _interopRequireDefault(require("./translation-ml.json"));
var _translationMr = _interopRequireDefault(require("./translation-mr.json"));
var _translationNb = _interopRequireDefault(require("./translation-nb.json"));
var _translationNl = _interopRequireDefault(require("./translation-nl.json"));
var _translationPl = _interopRequireDefault(require("./translation-pl.json"));
var _translationPt = _interopRequireDefault(require("./translation-pt.json"));
var _translationSv = _interopRequireDefault(require("./translation-sv.json"));
var _translationTa = _interopRequireDefault(require("./translation-ta.json"));
var _translationTe = _interopRequireDefault(require("./translation-te.json"));
var _translationTh = _interopRequireDefault(require("./translation-th.json"));
var _translationTr = _interopRequireDefault(require("./translation-tr.json"));
var _translationZh = _interopRequireDefault(require("./translation-zh.json"));
var _translation = _interopRequireDefault(require("./translation.json"));
// file-loader transforms JSON imports to resource URLs, so we cast our export accordingly here.
var i18nEndPointMap = {
  'translation-ar.json': _translationAr["default"],
  'translation-bn.json': _translationBn["default"],
  'translation-cs.json': _translationCs["default"],
  'translation-da.json': _translationDa["default"],
  'translation-de.json': _translationDe["default"],
  'translation-en.json': _translationEn["default"],
  'translation-es.json': _translationEs["default"],
  'translation-fr.json': _translationFr["default"],
  'translation-he.json': _translationHe["default"],
  'translation-hi.json': _translationHi["default"],
  'translation-id.json': _translationId["default"],
  'translation-it.json': _translationIt["default"],
  'translation-ja.json': _translationJa["default"],
  'translation-kn.json': _translationKn["default"],
  'translation-ko.json': _translationKo["default"],
  'translation-ml.json': _translationMl["default"],
  'translation-mr.json': _translationMr["default"],
  'translation-nb.json': _translationNb["default"],
  'translation-nl.json': _translationNl["default"],
  'translation-pl.json': _translationPl["default"],
  'translation-pt.json': _translationPt["default"],
  'translation-sv.json': _translationSv["default"],
  'translation-ta.json': _translationTa["default"],
  'translation-te.json': _translationTe["default"],
  'translation-th.json': _translationTh["default"],
  'translation-tr.json': _translationTr["default"],
  'translation-zh.json': _translationZh["default"],
  'translation.json': _translation["default"]
};
var _default = exports["default"] = i18nEndPointMap;